
























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MapObject, SelectedChannel, ChannelGroup } from '@/core/components/networkViewer/types';
import { LogisticsNetwork } from '@/dto/';
import MapObjectControls from './Controls/MapObjectControls.vue';
import ChannelControls from './Controls/ChannelControls.vue';
import MeasureDiv from './Shapes/MeasureDiv.vue';
@Component({
    components: {
        MapObjectControls,
        ChannelControls,
        MeasureDiv
    }
})
export default class ControlsTemplate extends Vue {
    @Prop({ type: Array, required: false }) public mapObjects!: MapObject[];
    @Prop({ type: Array, required: false }) public channels!: ChannelGroup[];
    @Prop({ type: Object, required: true }) public network!: LogisticsNetwork;
    @Prop({ type: Object, required: true }) public settings!: any;
    @Prop({ type: Object, required: true }) public model!: any;
    @Prop({ type: Object, required: false }) public selectedChannel!: SelectedChannel;

    public root: HTMLDivElement | null = null;

    private measure: MeasureDiv | null = null;
    private measureText: string = '';
    private measureStyle: string = '';

    private mounted() {
        const name = 'measure';
        const rootName = 'control-root';
        this.measure = this.$refs[name] as MeasureDiv;
        this.root = this.$refs[rootName] as HTMLDivElement;
    }

    private getWidth(text: string, styles: string) {
        return this.measure?.width(text, styles);
    }

    private getHeight(text: string, styles: string) {
        return this.measure?.height(text, styles);
    }

    private selectMapObject(
        mapObject: MapObject,
        related?: MapObject | null,
        updateSelectionControl: boolean = true,
        trigger: boolean = true,
        deselectChannel: boolean = true) {
        this.$emit('selectMapObject', mapObject, related);
    }

    private detailed(mapObject: MapObject) {
        this.$emit('detailed', mapObject);
    }

    private updateMapObjectName(mapObject: MapObject, name: string) {
        this.$emit('updateMapObjectName', mapObject, name);
    }
}
